import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd';
import { FormFieldInfo } from '../../../../models/forms-response.models';
@Component({
    selector: 'app-component-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleComponent implements AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() public formGroup: FormGroup;
    @Input() formData: any;
    formFieldConfig: any;
    fieldConfig: any;
    fieldCode: string = ''
    name: string;
    maxlength: string = '';
    hideTitle: boolean;
    isRefresh: boolean = false;
    value: string = '';
    tooltip: string;
    template: '';
    fieldDataInfo:any;
    constructor(private cdref: ChangeDetectorRef,private modal: NzModalService) {
    }

    ngOnInit(): void {
        this.formFieldConfig = JSON.parse(this.formFieldInfo.formFieldConfig);
        this.fieldDataInfo=this.formFieldInfo;
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }
}